import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CompletedActionCard',
  props: {
    buttonId: null,
    title: null,
    note: null,
    iconSrc: { default: '' },
    badge: { default: '' },
    ctaLabel: { default: '' },
    emphasis: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({ (e: 'click'): void }), expose: any, slots: any, attrs: any }) {

/**
 * 完了画面の 1 アクション = 1 カード。カード全体が 1 つの button で、
 * GTM のトリガーが見ている id は必ずこの外側 button に付く（中に button を入れない）。
 * ctaLabel を渡した場合は右端の矢印の代わりに塗りボタン風の見た目を出す。
 */




return { __sfc: true,emit }
}

})